"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PurchasesAPI = void 0;
const PurchasesAPIError_1 = require("./PurchasesAPIError");
const types_1 = require("./types");
class PurchasesAPI {
    constructor(http) {
        this.http = http;
    }
    /**
     * Redeem code on the backend
     *
     * @param code - code to redeem
     */
    redeemCode(code) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = {
                code,
            };
            const response = yield this.http.post({
                path: types_1.Path.RedeemCode,
                data,
            });
            if (!response.ok) {
                const { code: errorCode, error: message, organization, } = yield response.json();
                const payload = organization ? { organization } : undefined;
                throw new PurchasesAPIError_1.PurchasesAPIError(errorCode, message, payload);
            }
            return response.json();
        });
    }
}
exports.PurchasesAPI = PurchasesAPI;
